module.exports = __webpack_public_path__ + "static/preview-3c5df35e4bb1442410ad8ac51d3434a3.png";